import { BCDataGrid, BCExtremeGridEntities } from '@bimser/components';
import React from 'react';
import _camelCase from 'lodash/camelCase';
import {
	dateTimeFilterOptions,
	IDColumn,
	renderTags,
	renderTypeIcon,
	typeColumn
} from '../constants/defaultColumns';
import { dataTypes, dbTypes, defaultFilterOperations } from '../helper';
import filteringColumns from '../constants/filteringColumns';
import { IGridContextItem } from '../entities/IGridContextItem';

const customRenderColumns = ['TYPE', 'TAGS'];

const cellRender = (args: Parameters<BCDataGrid.Entities.IRemoteColumnProps['cellRender']>[0]) => {
	if (args.column.name == 'TYPE') {
		return renderTypeIcon(args);
	} else if (args.column.name == 'TAGS') {
		return renderTags(args);
	}
};

const useDMColumns = (
	sceneId: string,
	gridContextItems: Array<IGridContextItem>
): Array<BCDataGrid.Entities.IRemoteColumnProps> => {
	const hiddenColumns = JSON.parse(localStorage.getItem('dmHiddenColumns') || '{}');

	return React.useMemo(() => {
		const columns = [typeColumn, ...gridContextItems].map(
			(col, index): BCDataGrid.Entities.IRemoteColumnProps => {
				const dataType = dataTypes(_camelCase(col.dataType));

				return {
					name: col.name,
					dataField: col.name,
					caption: col.caption,
					allowHiding: col.name !== 'NAME',
					dataType,
					allowFiltering:
						filteringColumns.indexOf(col.name) > -1 ||
						col.name.startsWith('metadatafieldvalue_'),
					allowSorting: !col.name.startsWith('metadatafieldvalue_'),
					visible: !hiddenColumns[sceneId]?.includes(col.name),
					alignment: col.name == 'TYPE' ? 'center' : 'left',
					width: col.name == 'TYPE' ? 100 : undefined,
					visibleIndex: index,
					selectedFilterOperation: dataType === 'string' ? 'contains' : '=',
					dbType: dbTypes(dataType),
					filterOperations: defaultFilterOperations(dataType),
					editorOptions:
						dataType === 'date' || dataType === 'datetime'
							? dateTimeFilterOptions
							: undefined,
					cellRender: customRenderColumns.includes(col.name) ? cellRender : undefined
				};
			}
		);

		const idColumn: BCDataGrid.Entities.IRemoteColumnProps = {
			...IDColumn,
			dbType: BCExtremeGridEntities.ItemType.Int64
		};

		return [idColumn, ...columns];
	}, [gridContextItems]);
};

export default useDMColumns;
